import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import HintBox from '../HintBox'

export function TerminAzubiHintBox({conflictExists, potentialTermineCount}) {
  return (
    <>
      {conflictExists?.ausbilderTerminConflict && (
        <HintBox modifier="warning" text={i18n.t('termin_notdeletable_hint_azubi')} />
      )}
      {!conflictExists?.ausbilderTerminConflict && conflictExists?.azubiTerminConflict && (
        <HintBox modifier="warning" text={i18n.t('termin_conflictexists_hint')} />
      )}
      {!conflictExists?.ausbilderTerminConflict &&
        !conflictExists?.azubiTerminConflict &&
        potentialTermineCount > 1 && (
          <HintBox modifier="warning" text={i18n.t('termin_manyterminecreated_hint', [potentialTermineCount])} />
        )}
    </>
  )
}
TerminAzubiHintBox.propTypes = {
  conflictExists: PropTypes.shape({
    ausbilderTerminConflict: PropTypes.bool,
    azubiTerminConflict: PropTypes.bool,
  }),
  potentialTermineCount: PropTypes.number,
}
